<template>
  <div class="advanced-query"
       ref="advanced_query">
    <slot></slot>

    <el-button type="text"
               :icon="drawerShow ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
               @click="openSearch()">高级搜索</el-button>
    <el-drawer title="高级搜索"
               :visible.sync="drawerShow"
               direction="ltr"
               top="3vh"
               :wrapperClosable="false"
               :modal-append-to-body="false"
               :append-to-body="false"
               :modal="false"
               size='35%'>
      <div class="drawer-content">
        <el-row :gutter="20"
                class="row-condition">
          <el-col :span="12"
                  class="seach-add">增加条件</el-col>
          <el-col :span="10">
            <el-select v-model="searchItem"
                       value-key="prop"
                       placeholder="请选择"
                       @change="selectChange">
              <el-option v-for="item in filterList"
                         :key="item.prop"
                         :label="item.label"
                         :value="item">
              </el-option>
            </el-select>
          </el-col>

        </el-row>
        <div class="condition-item"
             v-for="(item, index) in searchList"
             :key="index">
          <el-row class="row-title">{{item.label}}：</el-row>
          <el-row :gutter="20"
                  class="row-condition">
            <el-col :span="6">
              <el-select v-model="item.filterType"
                         :disabled="item.disabled||item.type==='datetime'"
                         :placeholder="item.type == 'datetime'? '':'请选择'">
                <el-option v-for="itemT in filterTypeOptions"
                           :key="itemT.value"
                           :label="itemT.label"
                           :value="
                           itemT.value">
                </el-option>
              </el-select>
            </el-col>
            <!-- 输入条件的四种形式 1. 输入框input 2. 下拉框select 3.级联选择cascader 4.时间选择datetime -->
            <el-col :span="16">
              <template v-if="getSlotName(item, $scopedSlots)">
                <slot :name="getSlotName(item)"
                      :row="item"></slot>
              </template>
              <template v-else-if="item.type==='input'">
                <el-input v-model="item.paramsVal"
                          placeholder="请输入"></el-input>
              </template>
              <template v-else-if="item.type==='select'">
                <el-select v-model="item.paramsVal"
                           :filterable="item.remote||false"
                           :remote="item.remote||false"
                           :remote-method="(query)=>remoteMethod(query,item)"
                           placeholder="请选择">
                  <el-option v-for="(dicDataItem,dicDataIndexc) in item.dicData"
                             :key="dicDataIndexc"
                             :label="dicDataItem[item.props.label]"
                             :value="dicDataItem[item.props.value]">
                  </el-option>
                </el-select>
              </template>
              <template v-else-if="item.type==='tree'">
                <el-cascader v-model="item.paramsVal"
                             :options="item.dicData"
                             :show-all-levels="false"
                             collapse-tags
                             :props="{
                                    expandTrigger: 'hover',
                                    emitPath:false,
                                    label: 'deptName',
                                    value: 'id',
                                    children: 'children',
                                    multiple: true,
                                    checkStrictly: true,
                              }"
                             clearable>
                </el-cascader>
              </template>
              <template v-else-if="item.type==='datetime'">
                <el-date-picker v-model="item.paramsVal"
                                type="datetimerange"
                                :value-format='"yyyy-MM-dd HH:mm:ss"'
                                :default-time="['00:00:00', '23:59:59']"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
              </template>
            </el-col>
            <el-col :span="2"
                    class="delete-item">
              <el-button type="text"
                         @click="deleteQuery({item,index})"
                         icon="el-icon-delete"></el-button>
            </el-col>
          </el-row>
        </div>

        <div class="foot-btn">
          <el-button icon="el-icon-delete"
                     @click="handleReset">清空查询项</el-button>
          <el-tooltip class="item"
                      effect="dark"
                      content="综合普通查询和高级查询进行检索，重复条件将以高级查询条件为准"
                      placement="top-start">
            <el-button type="primary"
                       :loading="loading"
                       icon="el-icon-search"
                       @click="handleSearch('syn')">复合搜索</el-button>
          </el-tooltip>

          <el-tooltip class="item"
                      effect="dark"
                      content="仅把高级查询条件进行检索"
                      placement="top-start">
            <el-button type="primary"
                       :loading="loading"
                       icon="el-icon-search"
                       @click="handleSearch('only')">高级搜索</el-button>
          </el-tooltip>
        </div>

      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getDictionaries } from '@/basic-common/util/dictionaries'
import autocomplete_config from '@/basic-common/util/autocomplete-config.js' // 常用拼音码配置集

/**
 * @desc 重构表格操作组件
 * @param THIS_TO_PARENT { Object } 父级 this
 * @param optionName { String }  option 配置文件名称
 * @param refName { String } 父级表格 ref 绑定名称
 */
export default {
  name: 'AdvancedQuery',
  props: {
    // 父级this
    THIS_TO_PARENT: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 字段配置：Column-共用属性
    fieldsColumns: {
      type: Array,
      default: () => {
        return []
      },
    },
    optionName: {
      type: String,
      default: 'option',
    },
    refName: {
      type: String,
      default: 'crud',
    },
    query: {
      type: Object,
      default: () => {
        return {}
      },
    },
    likeLsit: {
      type: Object,
      default: () => {
        return []
      },
    },
  },

  data() {
    return {
      loading: false,
      filterTypeOptions: [
        {
          value: 'eq',
          label: '等于',
        },
        {
          value: 'ne',
          label: '不等于',
        },
        {
          value: 'gt',
          label: '大于',
        },
        {
          value: 'lt',
          label: '小于',
        },
        {
          value: 'ge',
          label: '大于等于',
        },
        {
          value: 'le',
          label: '小于等于',
        },
        {
          value: 'between',
          label: '区间',
        },
        {
          value: 'like',
          label: '模糊',
        },
      ],
      drawerShow: false,
      data: this.THIS_TO_PARENT[this.optionName].column || [],
      filterList: [],
      searchItem: '',
      searchList: [],
      autoCompleteConfigList: Object.keys(autocomplete_config),
    }
  },
  watch: {
    drawerShow: {
      immediate: true,
      handler(val) {
        // 添加边界禁用效果
        val &&
          this.$nextTick(() => {
            const advancedQery = this.$refs.advanced_query
            const dialogHeaderEl =
              advancedQery.querySelector('.el-drawer__open')
            const drawer = advancedQery.querySelector('.el-drawer')
            dialogHeaderEl.style.cssText += ';cursor:not-allowed'
            drawer.style.cssText += ';cursor:auto'
          })
      },
    },
    fieldsColumns: {
      handler(newVal) {
        if (!this.validatenull(newVal)) {
          this.filterList = this.setListType(
            newVal.filter((item) => item.advancedSearch) || []
          )
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  computed: {},
  mounted() {
    if (this.validatenull(this.fieldsColumns)) {
      this.filterList = this.setListType(
        this.data.filter((item) => item.advancedSearch) || []
      )
    }
  },
  methods: {
    openSearch() {
      this.drawerShow = !this.drawerShow
    },
    // 删除高级查询项
    deleteQuery({ index }) {
      this.searchList.splice(index, 1)
    },
    // 手动添加时处理高级查询项
    selectChange(event) {
      // 过滤重复
      const verifyProp = this.searchList.find((item) => item.prop == event.prop)
      !verifyProp && this.setQueryList(event)
      this.searchItem = ''
    },
    // 拼音码远程搜索逻辑
    remoteMethod(query, item) {
      let dicUrl = '',
        parmas = {}
      // 拼音码处理
      if (this.autoCompleteConfigList.includes(item.columnModel)) {
        let autoComplete = autocomplete_config[item.columnModel]
        dicUrl = `${autoComplete.url}?searchCode=${query}`
        parmas = autoComplete.customQuery
      } else {
        // 其他下拉框
        dicUrl = item.dicUrl.replace('{{key}}', query)
      }
      getDictionaries(dicUrl, parmas).then((res) => {
        item.dicData = res
      })
    },

    // 高级查询项数据清洗
    async setQueryList(Objects) {
      if (['select', 'tree'].includes(Objects.type)) {
        // 非字段配置页面, 需主动请求字典接口
        if (this.validatenull(Objects.requestUrl)) {
          Objects.dicData = Objects.dicUrl
            ? await getDictionaries(Objects.dicUrl.replace('{{key}}', ''))
            : []
        }
      }
      this.searchList.push({ ...Objects, type: Objects.type || 'input' })
    },
    handleSearch(type) {
      if (this.searchList.length) {
        const searchMapList = []
        this.searchList.forEach((item) => {
          item.paramsVal &&
            item.paramsVal.length &&
            searchMapList.push({
              property: item.prop,
              value:
                item.paramsVal instanceof Array
                  ? item.paramsVal.join()
                  : item.paramsVal || '',
              operate:
                item.type === 'datetime' ? 'between' : item.filterType || '',
            })
        })
        if (searchMapList.length) {
          this.drawerShow = false
          this.$emit('advanceSearch', { searchList: searchMapList, type })
        } else {
          this.$message('拒绝检索，查询条件的值为空时将不会执行检索')
        }
      } else {
        this.$message('请添加高级检索的条件')
      }
    },
    // 清空所有查询项
    handleReset() {
      this.searchList = []
    },
    getSlotName(item = {}, slot) {
      let name = item.prop + 'Query'
      if (slot) return slot[name]
      return name
    },
    setListType(list) {
      this.likeLsit.length &&
        list.forEach((item) => {
          if (this.likeLsit.includes(item.prop)) {
            item.disabled = true
            item.filterType = 'like'
          }
        })
      return list
    },
  },
}
</script>

<style scoped lang="scss">
.advanced-query {
  display: inline-block;
  color: #606266;
  font-size: 14px;
  .is-circle {
    padding: 8px;
  }

  .delete-item {
    text-align: left;
    .el-button {
      padding-left: 0px;
    }
  }
  .el-drawer__body {
    padding-right: 20px;
  }
  .el-drawer__wrapper {
    box-shadow: 4px 4px 15px rgb(121, 114, 114);

    left: 266px;
    top: 115px;
    /deep/ .el-drawer__header {
      margin: 0;
      min-height: 20px;
      padding: 16px 10px 16px 24px;
      border-bottom: 1px solid #f0f0f0;
    }
    /deep/ .el-drawer__body {
      // padding: 30px 10px 60px 30px;
      margin: 10px 32px 86px 30px;
      overflow-x: hidden;
    }
  }
  .row-condition {
    display: flex;
    align-items: center;
    text-align: right;
  }
  .condition-item {
    .row-title {
      margin-bottom: 12px;
      margin: 10px auto 12px;
      text-align: left;
    }
  }
  .foot-btn {
    position: absolute;
    bottom: 32px;
    right: 12px;
    text-align: right;
  }
}
::v-deep .v-modal {
  left: 256px;
  top: 115px;
}
</style>
